export default __webpack_public_path__ + "static/media/dc3f4132a09e533e7d92546f22718073.png";